import { Container } from './styles'
import reactIcon from '../../assets/react-icon.svg'
import linkedin from '../../assets/linkedin.png'
import githubIcon from '../../assets/github.png'
import facebook from '../../assets/facebook (1).png'
import twitter from '../../assets/twitter.png'
import telegram from '../../assets/telegram.png'

export function Footer() {
  return (
    <Container className="footer">
      <a href="https://github.com/torikulislamv3" className="logo">
        <span className='text-blue-600'>Let's Go</span>
      </a>
      <div>
        <p>
          This Website was made with <img src={reactIcon} alt="React" />
        </p>
      </div>
      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/md-torikulislam"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/torikulislamv3"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://www.facebook.com/mdtorikulislamtamim/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebook} alt="facebook" />
        </a>
        <a
          href="https://x.com/TorikulIsl2041"
          target="_blank"
          rel="noreferrer"
        >
          <img src={twitter} alt="twitter" />
        </a>
        <a
          href="https://t.me/torikul567"
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="telegram" />
        </a>
      </div>
    </Container>
  )
}
